import { render } from "./PaginationPanel.vue?vue&type=template&id=eb98f394"
import script from "./PaginationPanel.vue?vue&type=script&lang=js"
export * from "./PaginationPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__